// saloni-quantity-selector
document.addEventListener('DOMContentLoaded', () => {
    window.QuantitySelector = class QuantitySelector {
        constructor() {
            if (window.QuantitySelector.instance) {
                return window.QuantitySelector.instance;
            }
            window.QuantitySelector.instance = this;
            this.init();
        }

        init() {
            // Listen for cart updates
            document.documentElement.addEventListener('cart:refresh', async (e) => {
                try {
                    // Skip if this is our own cart:refresh event with error
                    if (e.detail?.error) return;

                    // Use cart data from event or fetch if not available
                    const cart = e.detail?.cart || await (await fetch('/cart.js')).json();

                    // Update all variants with fresh cart data
                    cartQuantity = cartQuantity.map(item => {
                        const matchingCartItems = cart.items.filter(cartItem => cartItem.variant_id.toString() === item.id.toString());
                        const totalQty = matchingCartItems.reduce((sum, cartItem) => sum + cartItem.quantity, 0);

                        return {
                            ...item,
                            quantity: totalQty
                        };
                    });

                    // Update View Cart button count by calculating total from cartQuantity array
                    const viewCartButton = document.querySelectorAll('.view-cart-btn-container .cart-count');
                    if (viewCartButton) {
                        viewCartButton.forEach(btn => {
                            btn.textContent = cart.item_count;
                        });
                    }

                    // Get all product wrappers and sticky forms
                    const allProductWrappers = document.querySelectorAll('.product-item__cta-wrapper, .product-sticky-form, .product-form');

                    // Update each wrapper
                    allProductWrappers.forEach(wrapper => {
                        if (wrapper.classList.contains('product-sticky-form') || wrapper.classList.contains('product-form')) {
                            // For sticky form, get the current variant ID
                            const currentVariantId = wrapper.querySelector('input[name="properties[_variant_id]"]')?.value;
                            if (!currentVariantId) return;

                            // Find if current variant is in cart
                            const matchingItems = cart.items.filter(item => item.variant_id.toString() === currentVariantId);
                            const variantQty = matchingItems.reduce((sum, item) => sum + item.quantity, 0);

                            // Update UI for current variant
                            this.updateUI(wrapper, variantQty, cart);
                        } else {
                            // For product cards, use existing logic
                            const quantitySelector = wrapper.querySelector('.custom-quantity-selector');
                            const variantInput = wrapper.querySelector('input[name="id"]');
                            const productId = quantitySelector?.dataset.productId;

                            if (productId) {
                                const matchingItems = cart.items.filter(item => item.product_id.toString() === productId.toString());
                                const totalQty = matchingItems.reduce((sum, item) => sum + item.quantity, 0);
                                this.updateUI(wrapper, totalQty, cart);
                            } else {
                                const variantId = variantInput?.value || quantitySelector?.dataset.variantId;
                                if (!variantId) return;

                                const matchingItems = cart.items.filter(item => item.variant_id.toString() === variantId.toString());
                                const totalQty = matchingItems.reduce((sum, item) => sum + item.quantity, 0);
                                this.updateUI(wrapper, totalQty, cart);
                            }
                        }
                    });

                    // Hide all loaders after UI update
                    this.hideAllLoaders();
                } catch (error) {
                    console.error('Failed to sync cart quantities:', error);
                    this.hideAllLoaders();
                }
            });

            // Listen for quantity selector clicks
            document.addEventListener('click', async (e) => {
                // Add click handler for View Cart button on product page
                const viewCartBtn = e.target.closest('.product-sticky-form .view-cart-btn');
                const miniCart = document.querySelector('cart-drawer');

                if (viewCartBtn) {
                    // Open mini cart drawer
                    miniCart.setAttribute('open', '');

                    // try {
                    //     posthog.capture('view_cart_button_clicked', {
                    //         page_type: 'product',
                    //         page_url: window.location.href
                    //     });
                    // } catch (error) {
                    //     console.warn('Analytics tracking failed:', error);
                    // }
                }

                const button = e.target.closest('.custom-quantity-selector__button');
                if (!button) return;

                // Prevent multiple clicks
                if (button.disabled) return;

                const action = button.dataset.action;
                const productId = button.closest('.custom-quantity-selector').dataset.productId;
                const variantId = button.closest('.custom-quantity-selector').dataset.variantId;
                const qvQtyButton = button.classList.contains('qv-qty-button');

                try {
                    let cartData;
                    if (action === 'increase' && !qvQtyButton) {
                        // Check max quantity first
                        const quantitySelector = button.closest('.custom-quantity-selector');
                        const maxQuantity = parseInt(quantitySelector.dataset.maxQuantity, 10);
                        const currentQty = parseInt(quantitySelector.querySelector('.quantity-selector__value').textContent, 10);

                        if (maxQuantity && currentQty == maxQuantity) {
                            // const productTitle = quantitySelector.closest('product-item').querySelector('.product-item-meta__title').textContent.trim();
                            // this.showErrorNotification(`Must have at most ${maxQuantity} of ${productTitle}`);
                            this.showErrorNotification(`Must have at most ${maxQuantity} of this item`);
                            return;
                        }

                        // Show loader on increase button
                        button.closest('.custom-quantity-selector').querySelector('.loader-button__loader').removeAttribute('hidden');

                        // First get current cart to find existing items
                        const currentCart = await (await fetch('/cart.js')).json();
                        const existingItems = currentCart.items.filter(item => item.variant_id.toString() === variantId.toString());

                        // Update the first item's quantity if it exists, otherwise add new item
                        if (existingItems.length > 0) {
                            const firstItem = existingItems[0];
                            const response = await fetch('/cart/change.js', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({
                                    id: firstItem.key,
                                    quantity: firstItem.quantity + 1
                                })
                            });

                            cartData = await response.json();
                            if (!response.ok) throw new Error(cartData.message || 'Failed to update item');
                        } else {
                            // Add new item if none exists
                            const response = await fetch('/cart/add.js', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({
                                    items: [{ id: variantId, quantity: 1 }]
                                })
                            });

                            cartData = await response.json();
                            if (!response.ok) throw new Error(cartData.message || 'Failed to add item');
                        }

                        // try {
                        //     posthog.capture('qs_plus_clicked', {
                        //         page_url: window.location.href,
                        //         product_id: productId,
                        //         variant_id: variantId
                        //     });
                        // } catch (error) {
                        //     console.warn('Analytics tracking failed:', error);
                        // }
                    } else if (action === 'decrease' && !qvQtyButton) {
                        // Show loader on decrease button
                        button.closest('.custom-quantity-selector').querySelector('.loader-button__loader').removeAttribute('hidden');

                        // Get current cart to find all line items of this variant
                        const cart = await (await fetch('/cart.js')).json();
                        const lineItems = cart.items.filter(item => item.variant_id.toString() === variantId.toString());

                        if (lineItems.length > 0) {
                            // Calculate total quantity across all line items
                            const totalQty = lineItems.reduce((sum, item) => sum + item.quantity, 0);

                            if (totalQty === 1) {
                                // If total quantity is 1, remove all line items
                                for (const item of lineItems) {
                                    const response = await fetch('/cart/change.js', {
                                        method: 'POST',
                                        headers: { 'Content-Type': 'application/json' },
                                        body: JSON.stringify({
                                            id: item.key,
                                            quantity: 0
                                        })
                                    });
                                    cartData = await response.json();
                                    if (!response.ok) throw new Error(cartData.message || 'Failed to update item');
                                }
                            } else {
                                // If total quantity > 1, decrease the first item's quantity
                                const firstItem = lineItems[0];
                                const response = await fetch('/cart/change.js', {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json' },
                                    body: JSON.stringify({
                                        id: firstItem.key,
                                        quantity: firstItem.quantity - 1
                                    })
                                });

                                cartData = await response.json();
                                if (!response.ok) throw new Error(cartData.message || 'Failed to update item');
                            }
                        }

                        // try {
                        //     posthog.capture('qs_minus_clicked', {
                        //         page_url: window.location.href,
                        //         product_id: productId,
                        //         variant_id: variantId
                        //     });
                        // } catch (error) {
                        //     console.warn('Analytics tracking failed:', error);
                        // }
                    } else {
                        if (screen.width <= 740) {
                            let phone_btn = button.closest('product-item').querySelector('.custom-product-btn .hidden-tablet-and-up')
                            phone_btn.click();
                            button.closest('.custom-quantity-selector').querySelector('.loader-button__loader').removeAttribute('hidden');
                            document.querySelector(`#${phone_btn.getAttribute("aria-controls")}`).addEventListener("openable-element:load:end", () => {
                                button.closest('.custom-quantity-selector').querySelector('.loader-button__loader').setAttribute('hidden', 'true')
                            });
                        } else {
                            let desk_btn = button.closest('product-item').querySelector('.custom-product-btn .hidden-phone');
                            desk_btn.click();
                            button.closest('.custom-quantity-selector').querySelector('.loader-button__loader').removeAttribute('hidden');
                            document.querySelector(`#${desk_btn.getAttribute("aria-controls")}`).addEventListener("openable-element:load:end", () => {
                                button.closest('.custom-quantity-selector').querySelector('.loader-button__loader').setAttribute('hidden', 'true')
                            });
                        }
                    }

                    // Trigger cart refresh to update UI with cart data if available
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                        bubbles: true,
                        detail: cartData ? { cart: cartData } : undefined
                    }));
                } catch (error) {
                    console.error('Cart operation failed:', error);
                    this.showErrorNotification(error.message);
                    // Hide loader on error
                    button.closest('.custom-quantity-selector').querySelector('.loader-button__loader').setAttribute('hidden', 'true');
                }
            });
        }

        async updateUI(wrapper, qty, cartData = null) {
            // Handle sticky form and product form case
            if (wrapper.classList.contains('product-sticky-form') || wrapper.classList.contains('product-form')) {
                const atcButton = wrapper.querySelector('#StickyAddToCart') || wrapper.querySelector('#AddToCart');
                const viewCartBtnContainer = wrapper.querySelector('.view-cart-btn-container');
                const formInfoContainer = wrapper.querySelector('.product-sticky-form__info');
                const variantContainer = wrapper.querySelector('[data-variant-container]');
                if (!variantContainer) return;

                const quantitySelector = variantContainer.querySelector('.custom-quantity-selector');
                if (!quantitySelector) return;

                const variantId = quantitySelector.dataset.variantId;
                if (!variantId) return;

                // Use provided cart data or fetch if not available
                const cart = cartData || await (await fetch('/cart.js')).json();

                // Find if variant is in cart and its quantity
                const matchingItems = cart.items.filter(item => item.variant_id.toString() === variantId);
                const variantQty = matchingItems.reduce((sum, item) => sum + item.quantity, 0);

                // Update UI based on cart quantity
                if (variantQty === 0) {
                    // Show ATC button, hide quantity selector
                    if (quantitySelector) {
                        quantitySelector.style.display = 'none';
                        // Wait for the display none to take effect
                        await new Promise(resolve => setTimeout(resolve, 50));
                    }
                    if (atcButton) atcButton.style.display = 'block';
                    if (viewCartBtnContainer) viewCartBtnContainer.style.display = 'none';
                    if (formInfoContainer) formInfoContainer.classList.remove('hidden-pocket');
                } else {
                    // Hide ATC button, show and update quantity selector
                    if (atcButton) {
                        atcButton.style.display = 'none';
                        // Wait for the display none to take effect
                        await new Promise(resolve => setTimeout(resolve, 50));
                    }
                    if (quantitySelector) {
                        quantitySelector.style.display = 'flex';
                        const valueElement = quantitySelector.querySelector('.quantity-selector__value');
                        if (valueElement) valueElement.textContent = variantQty.toString();
                    }
                    if (viewCartBtnContainer) viewCartBtnContainer.style.display = 'flex';
                    if (formInfoContainer) formInfoContainer.classList.add('hidden-pocket');
                }
                return;
            }

            // Handle product card case
            const productItem = wrapper.closest('product-item');
            if (!productItem) return;

            const atcButton = productItem.querySelector('.custom-product-btn');
            const quantitySelector = productItem.querySelector('.custom-quantity-selector');

            if (qty === 0) {
                // Show ATC button, hide quantity selector
                if (atcButton) atcButton.style.display = 'block';
                if (quantitySelector) quantitySelector.style.display = 'none';
            } else {
                // Hide ATC button, show and update quantity selector
                if (atcButton) atcButton.style.display = 'none';
                if (quantitySelector) {
                    quantitySelector.style.display = 'flex';
                    const valueElement = quantitySelector.querySelector('.quantity-selector__value');
                    if (valueElement) valueElement.textContent = qty.toString();
                }
            }
        }

        showErrorNotification(message) {
            const cartNotification = document.querySelector('.cart-notification');
            if (!cartNotification) return;

            cartNotification.classList.add('cart-notification--error');
            cartNotification.innerHTML = `
        <div class="cart-notification__overflow">
          <div class="container">
            <div class="cart-notification__wrapper">
              <svg focusable="false" width="20" height="20" class="icon icon--cart-notification" viewBox="0 0 20 20">
                <rect width="20" height="20" rx="10" fill="currentColor"></rect>
                <path d="M9.6748 13.2798C9.90332 13.0555 10.1763 12.9434 10.4937 12.9434C10.811 12.9434 11.0819 13.0555 11.3062 13.2798C11.5347 13.5041 11.6489 13.7749 11.6489 14.0923C11.6489 14.4097 11.5347 14.6847 11.3062 14.9175C11.0819 15.146 10.811 15.2603 10.4937 15.2603C10.1763 15.2603 9.90332 15.146 9.6748 14.9175C9.45052 14.6847 9.33838 14.4097 9.33838 14.0923C9.33838 13.7749 9.45052 13.5041 9.6748 13.2798ZM9.56689 12.1816V5.19922H11.4141V12.1816H9.56689Z" fill="rgb(var(--error-color))"></path>
              </svg>
              <div class="cart-notification__text-wrapper">
                <span class="cart-notification__heading heading">${message}</span>
              </div>
              <button class="cart-notification__close tap-area hidden-phone" data-action="close">
                <span class="visually-hidden">Close</span>
                <svg focusable="false" width="14" height="14" class="icon icon--close icon--inline" viewBox="0 0 14 14">
                  <path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="2" fill="none"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      `;

            const cartNotificationError = document.querySelector('.cart-notification-error');
            if (cartNotificationError) {
                cartNotificationError.style.display = 'flex';
                cartNotificationError.querySelector('.cart-notification-error-text').textContent = message;
                setTimeout(() => {
                    cartNotificationError.style.display = 'none';
                }, 3000);
            }

            // Add click handler for close button
            const closeButton = cartNotification.querySelector('.cart-notification__close');
            if (closeButton) {
                closeButton.addEventListener('click', () => {
                    cartNotification.setAttribute('hidden', '');
                });
            }

            cartNotification.removeAttribute('hidden');

            // Auto-hide after 3 seconds
            setTimeout(() => {
                cartNotification.setAttribute('hidden', '');
            }, 3000);
        }

        hideAllLoaders() {
            document.querySelectorAll('.custom-quantity-selector .loader-button__loader').forEach(loader => {
                loader.setAttribute('hidden', 'true');
            });
        }
    }

    // Initialize the quantity selector
    new QuantitySelector();
});

class QtyBox extends HTMLDivElement {
    connectedCallback() {
        const atcButton = this.closest('product-sticky-form')?.querySelector('#StickyAddToCart') || this.closest('.product-form')?.querySelector('#AddToCart');
        let quantity = cartQuantity.find(item => item.id.toString() === this.dataset.variantId.toString());
        const viewCartBtnContainer = this.closest('product-sticky-form')?.querySelector('.view-cart-btn-container');
        const formInfoContainer = this.closest('product-sticky-form')?.querySelector('.product-sticky-form__info');

        // If variant not in cartQuantity array, add it with quantity 0
        if (!quantity) {
            quantity = {
                id: Number(this.dataset.variantId),
                product_id: Number(this.dataset.productId),
                quantity: 0
            };
            cartQuantity.push(quantity);
        }

        // Update UI based on quantity
        if (quantity.quantity > 0) {
            if (atcButton) atcButton.style.display = 'none';
            this.style.display = 'flex';
            const valueElement = this.querySelector('.quantity-selector__value');
            if (valueElement) valueElement.textContent = quantity.quantity;
            if (viewCartBtnContainer) viewCartBtnContainer.style.display = 'flex';
            if (formInfoContainer) formInfoContainer.classList.add('hidden-pocket');
        } else {
            if (atcButton) atcButton.style.display = 'block';
            this.style.display = 'none';
            if (viewCartBtnContainer) viewCartBtnContainer.style.display = 'none';
            if (formInfoContainer) formInfoContainer.classList.remove('hidden-pocket');
        }

        // Update View Cart button count based on cartQuantity array
        const viewCartCountElement = document.querySelectorAll('.view-cart-btn-container .cart-count');
        if (viewCartCountElement) {
            const totalQuantity = cartQuantity.reduce((sum, item) => sum + item.quantity, 0);
            viewCartCountElement.forEach(btn => {
                btn.textContent = totalQuantity;
            });
        }

        // const addToCartButton = document.querySelectorAll('.custom-product-btn.product-item__cta, #AddToCart');
        // addToCartButton.forEach(function (button) {
        //     button.addEventListener('click', function () {
        //         try {
        //             posthog.capture('atc_button_clicked', {
        //                 page_url: window.location.href,
        //                 product_id: button.closest('form').querySelector('[name="product-id"]').value,
        //                 variant_id: button.closest('form').querySelector('[name="id"]').value
        //             });
        //         } catch (error) {
        //             console.warn('Analytics tracking failed:', error);
        //         }
        //     });
        // });

        // const stickyAtcButton = document.querySelector('#StickyAddToCart');
        // if (stickyAtcButton) {
        //     stickyAtcButton.addEventListener('click', function () {
        //         const productSticky = this.closest('product-sticky-form');
        //         try {
        //             posthog.capture('atc_button_clicked', {
        //                 page_url: window.location.href,
        //                 product_id: productSticky?.querySelector('.custom-quantity-selector')?.dataset.productId,
        //                 variant_id: productSticky?.querySelector('[name="properties[_variant_id]"]')?.value
        //             });
        //         } catch (error) {
        //             console.warn('Analytics tracking failed:', error);
        //         }
        //     });
        // }
    }
}
customElements.define('qty-box', QtyBox, { extends: 'div' });